<template>
    <section class="exp-wrapper">
        <div class="shape1"></div>
        <div class="shape2"></div>
        <div class="exp-car">
            <v-carousel cycle show-arrows-on-hover hide-delimiters>
                <v-carousel-item v-for="(item,i) in items" :key="i" :src="item.src"></v-carousel-item>
            </v-carousel>
        </div>
        <article class="exp-text">
            <span class="exp-span1">{{$t('Home.Exp.span1')}}</span>
            <span class="exp-span2">{{$t('Home.Exp.span2')}}</span>
            <span class="exp-span2">{{$t('Home.Exp.span3')}}</span>
            <v-btn class="exp-btn" outlined color="#10424b">{{$t('Home.Exp.btn')}}</v-btn>
        </article>
    </section>
</template>

<script>
export default {
    name: 'home-exp',
    data() {
        return {
            items: [
                {
                    src: 'http://cssas.company/img/car_1.jpg',
                },
                {
                    src: 'http://cssas.company/img/car_2.jpg',
                },
                {
                    src: 'http://cssas.company/img/car_3.jpg',
                },
                {
                    src: 'http://cssas.company/img/car_4.jpg',
                },
                {
                    src: 'http://cssas.company/img/car_5.jpg',
                },
            ],
        }
    },
}
</script>

<style lang="scss">
@mixin mobile {
    @media only screen and (max-width: 700px) {
        @content;
    }
}

@mixin mobileBig {
    @media only screen and (max-width: 1400px) {
        @content;
    }
}
$shape-color: rgb(242, 242, 242);
.exp-wrapper {
    margin: 0 0 0 0;
    width: 100%;
    height: 700px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    @include mobile {
        flex-direction: column;
        height: auto;
    }
    .shape1 {
        position: absolute;
        margin: 0 0 0 -30%;
        width: 150px;
        height: 700px;
        background-color: $shape-color;
        z-index: 0;
        transform: skew(-20deg);
        @include mobile {
            width: 80px;
        }

    }
    .shape2 {
        position: absolute;
        margin: 0 0 0 30%;
        width: 150px;
        height: 700px;
        background-color: $shape-color;
        z-index: 0;
        transform: skew(-20deg);
        @include mobile {
            width: 80px;
        }
    }
    .exp-car {
        width: 60%;
        height: 500px;
        @include mobile {
            width: 100%;
            height: 300px;
        }
    }
    .exp-text {
        z-index: 1;
        width: 40%;
        height: 700px;
        display: flex;
        flex-direction: column;
        padding: 50px;
        text-align: left;
        justify-content: center;
        @include mobile {
            width: 100%;
            height: auto;
        }
        .exp-span1 {
            font-size: 34px;
            margin: 0 0 20px 0;
            @include mobile {
                font-size: 30px;
            }
        }
        .exp-span2 {
            font-size: 20px;
            margin: 0 0 15px 0;
            @include mobile {
                font-size: 18px;
            }
        }
        .exp-btn {
            width: 200px;
        }
    }
}
.v-image__image, .v-responsive__content, .v-window-item {
    @include mobile {
        height: 300px;
    }
}
</style>